<template>
  <div class="supplier-capacity-table-container">
    <a-table :columns="columns" :data-source="capacityTableData" :pagination="false" :scroll="{x:100,y:cusHeight}">
      <template slot="avgLoad" slot-scope="text">
        <span>{{ `${parseFloat((Number(text) * 100).toFixed(4))}%` }}</span>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  name: 'SchedulingInfoTable',
  props: {
    capacityTableData: {
      type: Array,
      default: () => []
    },
    cusHeight: {
      type: Number,
      default: 300
    }
  },
  // 监控cusHeight变化
  components: {
  },
  data () {
    // 查询参数
    return {
        data: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 2, 3, 4, 5, 1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 1, 2, 3, 4, 5],
      // 表格字段
      columns: [
        {
          title: '公司主体',
          width: 100,
          ellipsis: true,
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '日期',
          width: 80,
          dataIndex: 'startDate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '产能负荷',
          width: 100,
          dataIndex: 'avgLoad',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'avgLoad' }
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.supplier-capacity-table-container {
  padding-left: 10px;
}
</style>
